const isBonusApp = (app: V3.App): app is V3.BonusApp =>
  app.type === 'Bonus App';

const isGeneralApp = (app: V3.App): app is V3.GeneralApp =>
  app.type === 'General App';

const isProductApp = (app: V3.App): app is V3.ProductApp =>
  isBonusApp(app) || isGeneralApp(app) || app.type === 'Legacy Bonus App';

const isWorkspace = (app: V3.App): app is V3.Workspace =>
  app.type === 'Workspace';

const isLegacyBonusApp = (app: V3.App): app is V3.LegacyBonusApp =>
  app.type === 'Legacy Bonus App';

const appTypeCheckers = {
  isBonusApp,
  isGeneralApp,
  isProductApp,
  isWorkspace,
  isLegacyBonusApp,
};

export default appTypeCheckers;
